/**
 * API Configuration
 * All API base URLs are defined here and loaded from environment variables
 */

import { getEnvVar } from '../utils/authUtils'

// Base URLs
const DAM_BASE_URL = getEnvVar('REACT_APP_DAM_API_URL')
const MARKETPLACE_BASE_URL = getEnvVar('REACT_APP_MARKETPLACE_API_URL')
const IAM_BASE_URL = getEnvVar('REACT_APP_IAM_API_URL')
const AGENTSELLER_BASE_URL = getEnvVar('REACT_APP_AGENTSELLER_API_URL')

export const apiConfig = { 
  // API Endpoints
  dam: {
    baseUrl: DAM_BASE_URL,
    digitalAssets: `${DAM_BASE_URL}/digital-assets`,
    fileUpload: `${DAM_BASE_URL}/files/upload`,
  },

  marketplace: {
    baseUrl: MARKETPLACE_BASE_URL,
    assets: `${MARKETPLACE_BASE_URL}/assets`,
  },

  iam: {
    baseUrl: IAM_BASE_URL,
    publicUsers: (orgId: string) => `${IAM_BASE_URL}/public-users/${orgId}`,
    verifyInvitation: (orgId: string, ticketId: string) =>
      `${IAM_BASE_URL}/public-users/${orgId}/invitation/verify/${ticketId}`,
  },

  agentseller: {
    baseUrl: AGENTSELLER_BASE_URL,
    me: `${AGENTSELLER_BASE_URL}/agentseller/me`,
    verificationIdentity: `${AGENTSELLER_BASE_URL}/agentseller/verification/identity`,
    verificationTax: `${AGENTSELLER_BASE_URL}/agentseller/verification/tax`,
  },
};
